import Velocity from 'velocity-animate';

export function flyToFavorite (item) {
	var target = document.querySelector('#h-favorite'),
		btnFly,
		btnFlyStartX,
		btnFlyStartY,
		btnFlyFinalX,
		btnFlyFinalY,
		btnTemp;

	if (!item.classList.contains("active")) {

		btnTemp = document.querySelector('.check-favorites-fly');

		if (typeof(btnTemp) != 'undefined' && btnTemp != null) {
			btnTemp.remove();
		}


		btnFlyFinalY = target.getBoundingClientRect().top + pageYOffset;
		btnFlyFinalX = target.getBoundingClientRect().left;

		btnFly = document.createElement('div');
		btnFly.classList.add('check-favorites-fly');

		document.querySelector('body').appendChild(btnFly);

		btnFlyStartX = item.getBoundingClientRect().left;
		btnFlyStartY = item.getBoundingClientRect().top + pageYOffset;
		btnFly.style.top = btnFlyStartY + "px";
		btnFly.style.left = btnFlyStartX + "px";

		Velocity(document.querySelector('.check-favorites-fly'), "finish");
		Velocity(document.querySelector('.check-favorites-fly'), {top: btnFlyFinalY, left: btnFlyFinalX}, { duration: 750 });

		setTimeout(() => {
			btnFly.classList.add('done');

			setTimeout(function() {
				if (typeof(btnFly) != 'undefined' && btnFly != null) {
					btnFly.remove();
				}
			}, 800);
		}, 750);

	}
}



export function  scrollTo (target, isScroll = true, margin) {
    if (isScroll && document.querySelector(target) || target === 'up' || target === 'down') {
        margin = margin ? margin : 66;
        let $top;
		let $topMargin = (!document.querySelector('header')) ? 50 : document.querySelector('header').offsetHeight;
		
		let $warning = document.querySelector('.warning-top');
		let $warningMargin = !!$warning ? $warning.offsetHeight : 0;
		if(target === 'up'){
            $top = 0;
		} else if(target === 'down'){
			$top = document.body.scrollHeight;
		} else {
            let box = document.querySelector(target).getBoundingClientRect();
            $top = box.top + window.pageYOffset - $topMargin - $warningMargin - margin;
        }

        Velocity(document.querySelector('body'), "finish");
        Velocity(document.querySelector('body'),"scroll", { duration: 750, offset: $top });
    }
}

// необходимо блокам-родителям задавать positon: relative (для подсчета offsetTop)
export function  scrollToModal (target, isScroll = true, margin, targetWrap) {
    if (isScroll && document.querySelector(target) || target === 'up') {
        margin = margin ? margin : 24;
        var $top = 0;
        let tempElem = 'test';

        let tr = document.querySelector(target);
  		let pr = tr.parentNode;

        while(tempElem !== targetWrap && tempElem !== 'app') {
    		$top += parseFloat(pr.offsetTop);
        	pr = pr.parentNode;
        	tempElem = pr.id;
        }

        document.querySelector('#' + targetWrap).scrollTo({top: $top - margin, left: 0, behavior: 'smooth'});
    }
}


function iconFlyTo (target, btn) {
	var $target = $(target),
		$targetTop,
		$btn = $(btn),
		$btnMoved = $btn.clone(true).addClass('move-clone'),
		$posAdjust = { // поправка на центр цели
			top: ($target.outerHeight() / 2) - ($btn.outerHeight() / 2),
			left: ($target.outerWidth() / 2) - ($btn.outerWidth() / 2)
		},
		$btnMovedScroll; //поправка на скролл страницы


	if($target.is('.accepted')) $target.toggleClass('accepted', false);

	$targetTop = ($target.parents().is('.h')) ? 0 : $target.offset().top; //если элемент в фиксированной шапке

	$btnMovedScroll = $(document).scrollTop();

	if(!$btn.is('.active')) {
		$btn.toggleClass('active', true);
		$btnMoved.toggleClass('active', true).appendTo('body');
		$btnMoved.css({
			'position': 'fixed',
			'top': $btn.offset().top - $btnMovedScroll,
			'left': $btn.offset().left
		});

		$btnMoved.animate({
			'top': $targetTop + $posAdjust.top,
			'left': $target.offset().left + $posAdjust.left}, 550, function() {
				$target.toggleClass('accepted', true);
				$btnMoved.remove();
		});
	} else {
		$btn.toggleClass('active', false);
	}

}


export function flyToWork (item) {
	var target = document.querySelector('.flyToWork'),
		btnFly,
		btnFlyStartX,
		btnFlyStartY,
		btnFlyFinalX,
		btnFlyFinalY,
		btnTemp;

	if (!item.classList.contains("active")) {

		btnTemp = document.querySelector('.coupon-fly');

		if (typeof(btnTemp) != 'undefined' && btnTemp != null) {
			btnTemp.remove();
		}


		btnFlyFinalY = target.getBoundingClientRect().top + pageYOffset;
		btnFlyFinalX = target.getBoundingClientRect().left;

		btnFly = document.createElement('div');
		btnFly.classList.add('coupon', '--ghost', 'coupon-fly');
		btnFly.innerHTML = '<div class="coupon__wrap"><div class="coupon__img"></div> <div class="coupon__content"><div class="coupon__favorite"><span class="check-favorites"></span></div><div class="coupon__stat"><span class="elem --views"><span class="i i-eye"></span><span class="t"></span></span><span class="elem --buy"><span class="i i-cart"></span><span class="t"></span></span><span class="elem --comment"><span class="i i-comment"></span><span class="t"></span></span></div><div class="coupon__name">&nbsp;</div><div class="coupon__company">&nbsp;</div><div class="w"><div class="coupon__economy"><div class="t">Экономия</div><div class="p"></div></div><div class="coupon__info">Средний чек<span class="n" >%</span></div></div></div></div>'

		document.querySelector('body').appendChild(btnFly);

		btnFlyStartX = item.getBoundingClientRect().left;
		btnFlyStartY = item.getBoundingClientRect().top + pageYOffset;
		btnFly.style.top = btnFlyStartY + "px";
		btnFly.style.left = btnFlyStartX + "px";

		Velocity(document.querySelector('.coupon-fly'), "finish");
		Velocity(document.querySelector('.coupon-fly'), { top: btnFlyFinalY, left: btnFlyFinalX + 40, width: 0, height: 0, opacity: 0}, { duration: 750 });
		target.style.color="#fff";
		setTimeout(() => {
			btnFly.classList.add('done');
			target.style.color="";
			setTimeout(function() {
				if (typeof(btnFly) != 'undefined' && btnFly != null) {
					btnFly.remove();
				}
			}, 800);
		}, 750);

	}
}
// export default {
// 	actions
// }
